import React from 'react';
import '../styles/PricingSection.css';
import { FaCheckCircle, FaTools, FaCloud, FaMoneyBillWave, FaClock, FaGlobe, FaCubes, FaCar, FaUserClock, FaServer } from 'react-icons/fa';

const PricingSection = () => {
    return (
        <section id="pricing" className="pricing-section">
            <h2 className="pricing-title">Investasi Cerdas untuk Depot Air Anda</h2>
            <p className="pricing-intro-text">
                Dapatkan kendali penuh atas bisnis depot air minum Anda dengan paket **Depot Air Cerdas** yang transparan dan terjangkau. Pilih yang paling sesuai dengan kebutuhan Anda!
            </p>

            <div className="pricing-grid">
                {/* ✅ PAKET BARU: Paket Hemat (Rp1.000.000) */}
                <div className="pricing-card">
                    <div className="card-header">
                        <h3>Paket Hemat</h3>
                        <p className="price-tag">Rp1.000.000 <span className="old-price">Rp1.500.000</span></p>
                        <p className="price-desc">Solusi esensial untuk pemula</p>
                    </div>
                    <div className="card-body">
                        <h4>Fitur Utama Termasuk:</h4>
                        <ul className="feature-list">
                            <li><FaCheckCircle className="check-icon" /> Dashboard Web & Aplikasi Android</li>
                            <li><FaCheckCircle className="check-icon" /> Fitur Kasir & Hitung Pendapatan Otomatis</li>
                            <li><FaCheckCircle className="check-icon" /> Login Multi-Akun (Pemilik & Karyawan)</li>
                            <li><FaCheckCircle className="check-icon" /> Laporan Galon Harian & Bulanan</li>
                            <li><FaCheckCircle className="check-icon" /> Notifikasi Stok Air</li>
                            <li><FaCheckCircle className="check-icon" /> 2 Sensor Flow (untuk 2 keran)</li>
                            <li><FaCheckCircle className="check-icon" /> 1 Sensor Ultrasonik (untuk 1 tangki)</li>
                            <li><FaCheckCircle className="check-icon" /> Mikrokontroler & Kabel LAN</li>
                            <li><FaCheckCircle className="check-icon" /> Server Hosting Database & Dashboard (1 Tahun)</li>
                        </ul>
                    </div>
                    <div className="card-footer">
                        <a href="/register" className="btn-action">Pilih Paket Ini</a>
                    </div>
                </div>

                {/* ✅ PAKET BARU: Paket Optimal (Rp2.000.000) */}
                <div className="pricing-card featured-card"> {/* Menambahkan kelas 'featured-card' untuk penonjolan */}
                    <div className="card-header">
                        <span className="badge">Rekomendasi!</span>
                        <h3>Paket Optimal</h3>
                        <p className="price-tag">Rp2.000.000 <span className="old-price">Rp2.800.000</span></p>
                        <p className="price-desc">Solusi lengkap dan efisien</p>
                    </div>
                    <div className="card-body">
                        <h4>Fitur Utama Termasuk:</h4>
                        <ul className="feature-list">
                            <li><FaCheckCircle className="check-icon" /> Dashboard Web & Aplikasi Android</li>
                            <li><FaCheckCircle className="check-icon" /> Fitur Kasir & Hitung Pendapatan Otomatis</li>
                            <li><FaCheckCircle className="check-icon" /> Login Multi-Akun (Pemilik & Karyawan)</li>
                            <li><FaCheckCircle className="check-icon" /> Laporan Galon Harian, Mingguan, Bulanan</li>
                            <li><FaCheckCircle className="check-icon" /> Notifikasi Otomatis (Kebocoran/Anomali)</li>
                            <li><FaCheckCircle className="check-icon" /> Keamanan Sistem Terjamin</li>
                            <li><FaCheckCircle className="check-icon" /> 3 Sensor Flow (untuk 3 keran)</li>
                            <li><FaCheckCircle className="check-icon" /> 2 Sensor Ultrasonik (untuk 2 tangki)</li>
                            <li><FaCheckCircle className="check-icon" /> Mikrokontroler & Kabel LAN</li>
                            <li><FaCheckCircle className="check-icon" /> Server Hosting Database & Dashboard (1 Tahun)</li>
                        </ul>
                    </div>
                    <div className="card-footer">
                        <a href="/register" className="btn-action">Pilih Paket Ini</a>
                    </div>
                </div>

                {/* ✅ PAKET EXISTING: Paket Lengkap (Rp3.500.000) - Sebelumnya Starter Kit Lengkap */}
                <div className="pricing-card">
                    <div className="card-header">
                        <h3>Paket Lengkap</h3>
                        <p className="price-tag">Rp3.500.000 <span className="old-price">Rp6.500.000</span></p>
                        <p className="price-desc">Pilihan terbaik untuk kendali penuh</p>
                    </div>
                    <div className="card-body">
                        <h4>Fitur Utama Termasuk:</h4>
                        <ul className="feature-list">
                            <li><FaCheckCircle className="check-icon" /> Dashboard Web & Aplikasi Android</li>
                            <li><FaCheckCircle className="check-icon" /> Fitur Kasir & Hitung Pendapatan Otomatis</li>
                            <li><FaCheckCircle className="check-icon" /> Login Multi-Akun (Pemilik & Karyawan)</li>
                            <li><FaCheckCircle className="check-icon" /> Laporan Galon Harian, Mingguan, Bulanan</li>
                            <li><FaCheckCircle className="check-icon" /> Notifikasi Otomatis (Kebocoran/Anomali)</li>
                            <li><FaCheckCircle className="check-icon" /> Keamanan Sistem Terjamin</li>
                            <li><FaCheckCircle className="check-icon" /> 3 Sensor Flow (untuk 3 keran)</li>
                            <li><FaCheckCircle className="check-icon" /> 3 Sensor Ultrasonik (untuk 3 tangki)</li>
                            <li><FaCheckCircle className="check-icon" /> Mikrokontroler & Kabel LAN</li>
                            <li><FaCheckCircle className="check-icon" /> Server Hosting Database & Dashboard (1 Tahun)</li>
                        </ul>
                    </div>
                    <div className="card-footer">
                        <a href="/register" className="btn-action">Pilih Paket Ini</a>
                    </div>
                </div>
            </div>

            {/* Biaya Berkala dan Fitur Opsional tetap ada di bawah, tidak dalam grid utama */}
            <div className="secondary-info-grid">
                {/* Biaya Berlangganan Berkala */}
                <div className="pricing-card secondary-card">
                    <div className="card-header">
                        <h3>Biaya Berlangganan Berkala</h3>
                    </div>
                    <div className="card-body">
                        <ul className="feature-list">
                            <li><FaServer className="icon" /> Perpanjangan Server (Tahunan): <span className="highlight-text">Rp150.000/tahun</span><br /><small>Diperlukan setelah 1 tahun penggunaan Starter Kit.</small></li>
                            <li><FaClock className="icon" /> Perpanjangan Server (Bulanan): <span className="highlight-text">Rp20.000/bulan</span><br /><small>Alternatif jika tidak ingin perpanjangan tahunan.</small></li>
                        </ul>
                    </div>
                </div>

                {/* Fitur Opsional */}
                <div className="pricing-card secondary-card">
                    <div className="card-header">
                        <h3>Fitur Tambahan (Opsional)</h3>
                    </div>
                    <div className="card-body">
                        <ul className="feature-list">
                            <li><FaCubes className="icon" /> Tambah CCTV: <span className="highlight-text">Rp1.000.000</span><br /><small>Pantau depot langsung dari HP Anda, 24/7.</small></li>
                            <li><FaCar className="icon" /> Tambah GPS Kendaraan: <span className="highlight-text">Rp1.000.000</span><br /><small>Lacak lokasi pengiriman galon secara real-time.</small></li>
                            <li><FaUserClock className="icon" /> Tambah Sistem Absensi Pegawai: <span className="highlight-text">Rp2.000.000</span><br /><small>Cek kehadiran dan jadwal kerja karyawan secara digital.</small></li>
                        </ul>
                    </div>
                </div>
            </div> {/* Akhir dari secondary-info-grid */}
        </section>
    );
};

export default PricingSection;